/*eslint-disable*/
// chakra imports
import {
  Box,
  Flex,
  Text,
  Link,
  HStack,
  VStack,
  Icon,
  useColorModeValue,
  Heading,
  Spacer,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  useDisclosure,
} from "@chakra-ui/react";
import { ChevronDownIcon, SettingsIcon } from "@chakra-ui/icons";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import IconBox from "components/Icons/IconBox";
import { CreativeTimLogo } from "components/Icons/Icons";
import { Separator } from "components/Separator/Separator";
import PropTypes from "prop-types";
import React from "react";
import { NavLink, useLocation } from "react-router-dom";

export default function Header(props) {
  const { routes } = props;
  let location = useLocation();
  const { isOpen, onOpen, onClose } = useDisclosure();

  // verifies if routeName is one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname === routeName ? "active" : "";
  };

  // Chakra Color Mode
  let activeBg = useColorModeValue("white", "gray.700");
  let inactiveBg = useColorModeValue("white", "gray.700");
  let activeColor = useColorModeValue("gray.700", "white");
  let inactiveColor = useColorModeValue("gray.400", "gray.400");
  let activeBgHover = useColorModeValue("gray.100", "gray.800");

  // this function creates links that appear in header navigation
  const createLinks = (routes) => {
    return routes.map((prop, key) => {
      if (prop.redirect) {
        return null;
      }
      if (prop.hideInHeader) {
        return null;
      }
      if (prop.category) {
        return <div key={key}>{createLinks(prop.views)}</div>;
      }

      // Logic for Auth links visibility
      const user = localStorage.getItem("user");
      if (prop.name === "Salir" && !user) {
        return null;
      }
      if ((prop.name === "Ingresar" || prop.name === "Registrarse") && user) {
        return null;
      }

      return (
        <NavLink key={key} to={prop.layout + prop.path}>
          <Box
            bg={
              activeRoute(prop.layout + prop.path) === "active"
                ? activeBg
                : "transparent"
            }
            color={
              activeRoute(prop.layout + prop.path) === "active"
                ? activeColor
                : inactiveColor
            }
            _hover={{
              bg: activeBgHover,
              color:
                activeRoute(prop.layout + prop.path) === "active"
                  ? activeColor
                  : activeColor,
            }}
            px="4"
            py="2"
            rounded="md"
            transition="all 0.2s ease"
            fontWeight="medium"
          >
            {prop.icon ? (
              <HStack spacing={2}>
                <IconBox
                  bg="inherit"
                  color="inherit"
                  h="30px"
                  w="30px"
                  borderRadius="12px"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  {prop.icon}
                </IconBox>
                <Text>{prop.name}</Text>
              </HStack>
            ) : (
              <Text>{prop.name}</Text>
            )}
          </Box>
        </NavLink>
      );
    });
  };

  const brandText = useColorModeValue("gray.700", "gray.200");
  const mainText = useColorModeValue("gray.700", "white");
  const navbarBg = useColorModeValue("white", "gray.800");
  const navbarShadow = useColorModeValue(
    "0px 2px 8px rgba(0,0,0,0.1)",
    "0px 2px 8px rgba(0,0,0,0.3)"
  );

  return (
    <Box
      bg={navbarBg}
      boxShadow="0px 4px 12px rgba(0, 0, 0, 0.05)"
      borderBottom="1px solid"
      borderColor={useColorModeValue("gray.100", "gray.700")}
      position="fixed"
      top="0"
      left="0"
      right="0"
      zIndex="1000"
      height="70px"
      display="flex"
      alignItems="center"
    >
      <Flex
        px={{ base: "4", md: "8" }}
        justify="space-between"
        align="center"
        w="100%"
        maxW="100%"
        h="100%"
      >
        {/* Logo y Brand */}
        <HStack spacing={6} align="center">
          <Link href="#/" _hover={{ textDecoration: "none" }}>
            <Box display="flex" alignItems="center">
              <img
                src="https://administracion.dlds.cl/newdlds/logodldsnew.svg"
                alt="DLDS Logo"
                style={{ height: "40px", width: "auto" }}
              />
            </Box>
          </Link>

          <Box height="24px" width="1px" bg="gray.200" display={{ base: "none", md: "block" }} />

          <VStack spacing={0} align="flex-start" display={{ base: "none", md: "flex" }}>
            <Text
              fontSize="md"
              fontWeight="bold"
              color={brandText}
              lineHeight="1.2"
            >
              Sistema de Picking
            </Text>
            <Text fontSize="xs" color={inactiveColor} fontWeight="medium">
              Panel de Control
            </Text>
          </VStack>
        </HStack>

        {/* Navigation Links - Desktop */}
        <HStack
          spacing={8}
          display={{ base: "none", lg: "flex" }}
          align="center"
          ml="auto"
        >
          {createLinks(routes.filter((route) => !route.hideInHeader))}
        </HStack>

        {/* Mobile Menu Button */}
        <Box display={{ base: "block", lg: "none" }}>
          <Menu>
            <MenuButton
              as={IconButton}
              icon={<ChevronDownIcon />}
              variant="ghost"
              fontSize="xl"
            />
            <MenuList>
              {routes
                .filter((route) => !route.hideInHeader)
                .map((prop, key) => {
                  if (prop.redirect || prop.category) return null;
                  return (
                    <MenuItem
                      key={key}
                      as={NavLink}
                      to={prop.layout + prop.path}
                    >
                      {prop.name}
                    </MenuItem>
                  );
                })}
            </MenuList>
          </Menu>
        </Box>


      </Flex>
    </Box>
  );
}

Header.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object),
  logoText: PropTypes.string,
};
